import { render, staticRenderFns } from "./dialogTransferCandidate.vue?vue&type=template&id=fe22a770&scoped=true"
import script from "./dialogTransferCandidate.vue?vue&type=script&lang=js"
export * from "./dialogTransferCandidate.vue?vue&type=script&lang=js"
import style0 from "./dialogTransferCandidate.vue?vue&type=style&index=0&id=fe22a770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe22a770",
  null
  
)

export default component.exports